import styled from 'styled-components';

const AppContainer = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 50px auto 0;
`;

export default AppContainer;